export default __webpack_public_path__ + "static/media/room-propolis-main.2b63ee31.jpg";